// export const environment = {
//   production: true,
//   environmentName: 'qa',
//   config: {
//     apiKey: "AIzaSyCf2jrlenybRLM9vWEvWexxJxfS7fdPAqI",
//     authDomain: "upmerch-qa.firebaseapp.com",
//     databaseURL: "https://upmerch-qa.firebaseio.com",
//     projectId: "upmerch-qa",
//     storageBucket: "upmerch-qa.appspot.com",
//     messagingSenderId: "379091642370",
//     appId: "1:379091642370:web:d7669467b2db9f49849f1b",
//     measurementId: "G-NXZYZ3B451",
//     visiableAfter : "570",
//     productionNewOrderEmailFunctionURL: "https://us-central1-upmerch-qa.cloudfunctions.net/SendToPPNewOrderEmails",
//     carrier_ids : ["se-116619", "se-116620"], // USPS id removed: "se-116618"
//     admin_uid: "WSUlOtlHamhIu2fFoTX6bB5ds302",
//     filtersproductscount: "https://proxy-qa.upmerch.com/filtersproductscount",
//     garmentsfilters: "https://proxy-qa.upmerch.com/garments-filters",
//     get_quote_sheet_fun_url: "https://script.google.com/macros/s/AKfycbzECndaUtW2ns8ahY1aCdCCdKGH5waBUUDwqTd0fbV3J4PrwEyvMqcY7w/exec",
//     proxy_url: "https://proxy-qa.upmerch.com/",
//     notification_mark_all_as_read: "https://proxy-qa.upmerch.com/notification-mark-all-as-read",
//     api_key: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9",
//     start_an_order_page_url:"https://script.google.com/macros/s/AKfycbyPsGL9q5xk1tXp4iNULiAr--9Lgh7Tbo-DHtc98qz0YlIaY_NbDRAl3zC4NoOfLYr1-Q/exec"
//   }
// };


export const environment = {
  production: true,
  environmentName: 'dev',
  config: {
    apiKey: "AIzaSyCUrW3bt3dzjGGCkx6Pz1SvYeNZobB4Lag",
    authDomain: "upmerch-dev-354f2.firebaseapp.com",
    databaseURL: "https://upmerch-dev-354f2.firebaseio.com",
    projectId: "upmerch-dev-354f2",
    storageBucket: "upmerch-dev-354f2.appspot.com",
    messagingSenderId: "205788728428",
    appId: "1:205788728428:web:9d3a20cd8c92f480555c49",
    measurementId: "G-345DXFRZMB",
    visiableAfter: "570",
    productionNewOrderEmailFunctionURL: "https://us-central1-upmerch-dev.cloudfunctions.net/SendToPPNewOrderEmails",
    carrier_ids: ["se-116619", "se-116620"],
    admin_uid: "2J5HzMYuamfD9O9VmUvPCaNz4Yg1",
    filtersproductscount: "https://proxy-dev.upmerch.com/filtersproductscount",
    garmentsfilters: "https://proxy-dev.upmerch.com/garments-filters",
    get_quote_sheet_fun_url: "https://script.google.com/macros/s/AKfycbwwF4bKjprJJmBNFrofNcO5zev4_29PmzIkwMB8pVZKHZHivJlWJM56h5P6kEgfYtZavQ/exec",
    proxy_url: "https://proxy-dev.upmerch.com/",
    notification_mark_all_as_read: "https://proxy-dev.upmerch.com/notification-mark-all-as-read",
    api_key: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9",
    start_an_order_page_url:"https://script.google.com/macros/s/AKfycbyPsGL9q5xk1tXp4iNULiAr--9Lgh7Tbo-DHtc98qz0YlIaY_NbDRAl3zC4NoOfLYr1-Q/exec"
  }
};